import React from "react";
import BlogTen from "../component/BlogTen";

function BlogTenContainer() {
  return <BlogTen />;
}
export default BlogTenContainer;
